import axios from 'axios';
import moment from 'moment';
import { AOC_API_HEALTH_CHECK_URL, AOC_API_HEALTH_CHECK_LIST_URL, AOC_API_HEALTH_CHECK_INITIATE_URL } from 'constants/api';

/**
 * Fetches list of run IDs from the API.
 */
export const getHealthCheckRunsList = async () => {
  try {
    const { data } = await axios.get(AOC_API_HEALTH_CHECK_LIST_URL);
    return data;
  } catch (error) {
    errorProcessing('fetching health check run list', error);
    throw error;
  }
};

/**
 *  Makes a call to backend API to retrieve details for a given run id
 * @param {*} runId the unique run identifier
 * @returns Details for a specific Run ID
 */
export const getHealthCheckRunDetail = async (runId) => {
  try {
    const { data } = await axios.get(`${AOC_API_HEALTH_CHECK_URL}/${runId}`);
    return data;
  } catch (error) {
    errorProcessing('fetching health check run detail', error);
    throw error;
  }
};

/**
 * Makes a call to backend API to initiate a new Health Check run
 * @returns {Promise<any>} - API response for initiation
 */
export const initiateHealthCheck = async () => {
  try {
    const runid = moment.utc().format('YYYYMMDDHHmmss') + '-O';
    const response = await axios.post(AOC_API_HEALTH_CHECK_INITIATE_URL, { runid });
    return response.data;
  } catch (error) {
    errorProcessing('initiating new health check run', error);
    throw error;
  }
};

const errorProcessing = (context, error) => {
  if (error.response) {
    console.error(`Error ${context}: Server error response received, `, error.response.data);
  } else if (error.request) {
    console.error(`Error ${context}: No response received from server`);
  } else {
    console.error(`Error ${context}:`, error.message);
  }
};

export default { getHealthCheckRunsList, getHealthCheckRunDetail, initiateHealthCheck };
